import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getIsLoggedIn } from "../../../../services/auth";

export const removeAuthCodeFromUrl = (url: string) => {
  const urlObject = new URL(url);
  urlObject.searchParams.delete("authCode");
  return urlObject.toString();
};

export const useEntryAuthWall = () => {
  const navigate = useNavigate();
  const { competitionUUID } = useParams();
  const authCode = new URLSearchParams(window.location.search).get("authCode");
  useEffect(() => {
    let url = `/${competitionUUID}/enter`;
    if (authCode) {
      url += `?authCode=${authCode}&authCodeUrl=${encodeURIComponent(
        removeAuthCodeFromUrl(window.location.toString())
      )}`;
    }
    if (!getIsLoggedIn()) {
      navigate(url, { replace: true });
    }
    // Disabled to run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useJudgeAuthWall = (next?: string) => {
  const navigate = useNavigate();
  const { competitionUUID } = useParams();
  const authCode = new URLSearchParams(window.location.search).get("authCode");
  useEffect(() => {
    if (!getIsLoggedIn()) {
      let url = `/${competitionUUID}/judge/onboarding`;
      if (authCode) {
        url += `?authCode=${authCode}&authCodeUrl=${encodeURIComponent(
          removeAuthCodeFromUrl(window.location.toString())
        )}`;
      }
      navigate(url, {
        replace: true,
        state: { next },
      });
    }
    // Disabled to run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
